import React from 'react'
import { Link } from 'react-router-dom'
import { FiPhone, FiMail } from 'react-icons/fi'

const Support = () => {
  return (
    <div className="support-page">
      <style>{`
        /* Match homepage: soft neutral background + consistent 16px horizontal gutter */
        .support-page { background: #f9fafb; min-height: calc(100vh - 70px); }
        .main-content:has(.support-page) { background: #f9fafb; }
        .page-content:has(.support-page) { background: #f9fafb; }

        body:has(.support-page) .page-content,
        body:has(.support-page) #layout-wrapper.no-topbar .page-content,
        body:has(.support-page) #layout-wrapper .page-content {
          padding-top: 0 !important;
          padding-bottom: 24px !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
        }
        body:has(.support-page) .container-fluid,
        body:has(.support-page) .container {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        /* Sticky header — bleeds edge-to-edge; horizontal padding matches .modern-panel-header */
        .support-page .page-header-sticky {
          padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
          margin: 0 -16px 16px !important;
          top: 0 !important;
          background: #f9fafb !important;
          border-bottom: 1px solid #eef2f7 !important;
          box-shadow: none !important;
        }
        @media (max-width: 991px) {
          .support-page .page-header-sticky {
            padding: 16px 16px 12px !important;
          }
        }
        @media (max-width: 767.98px) {
          .support-page .page-header-sticky {
            padding: 10px 16px 8px !important;
            margin: 0 -16px 8px !important;
            position: static !important;
          }
        }
        @media (max-width: 480px) {
          .support-page .page-header-sticky {
            padding: 10px 16px 8px !important;
            margin: 0 -16px 8px !important;
          }
        }
        .support-page .page-header-sticky h3 {
          font-size: 18px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
          letter-spacing: -0.01em !important;
          margin: 0 !important;
        }

        /* Modern panel — mirrors homepage .modern-panel */
        .support-page .support-panel {
          background: #fff;
          border: 1px solid #eef2f7;
          border-radius: 16px;
          box-shadow: 0 1px 2px rgba(15,23,42,0.03);
          padding: clamp(14px, 1.4vw, 22px);
          margin-bottom: 16px;
        }
        .support-page .support-panel-title {
          font-size: 15px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.01em;
          margin: 0 0 4px;
        }
        .support-page .support-panel-subtle {
          font-size: 11px;
          color: #94a3b8;
          font-weight: 500;
          margin: 0 0 14px;
        }

        /* Contact row */
        .support-page .support-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          border: 1px solid #f1f5f9;
          border-radius: 10px;
          background: #fff;
          transition: border-color 0.15s ease, background 0.15s ease;
          text-decoration: none;
          color: #0f172a;
        }
        .support-page .support-row + .support-row { margin-top: 10px; }
        .support-page .support-row:hover {
          border-color: #008695;
          background: rgba(0,134,149,0.04);
          color: #008695;
        }
        .support-page .support-row-icon {
          width: 34px; height: 34px;
          border-radius: 8px;
          display: inline-flex; align-items: center; justify-content: center;
          background: #ecfdf5;
          color: #059669;
          flex-shrink: 0;
        }
        .support-page .support-row-icon.is-mail {
          background: #eff6ff;
          color: #2563eb;
        }
        .support-page .support-row-label {
          font-size: 10.5px;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin: 0 0 2px;
        }
        .support-page .support-row-value {
          font-size: 13px;
          font-weight: 600;
          color: inherit;
          margin: 0;
          word-break: break-word;
        }

        /* FAQ empty state */
        .support-page .support-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 32px 16px;
          border: 1px dashed #e2e8f0;
          border-radius: 12px;
          background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
          color: #64748b;
        }
        .support-page .support-empty-icon {
          width: 44px; height: 44px;
          display: inline-flex; align-items: center; justify-content: center;
          border-radius: 999px;
          background: #fff;
          color: #94a3b8;
          border: 1px solid #eef2f7;
          margin-bottom: 10px;
        }
        .support-page .support-empty-title {
          font-size: 13px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 2px;
        }
        .support-page .support-empty-sub {
          font-size: 11.5px;
          font-weight: 500;
          margin: 0;
        }

        .support-page .support-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        @media (min-width: 992px) {
          .support-page .support-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
      `}</style>

      <div className="page-header-sticky">
        <h3 className="fw-bold">Support</h3>
      </div>

      <div className="support-panel">
        <h5 className="support-panel-title">Contact Details</h5>
        <p className="support-panel-subtle">Reach out to our team for help or partnership queries.</p>

        <Link className="support-row" to="tel:+91-8639585257">
          <span className="support-row-icon">
            <FiPhone size={16} />
          </span>
          <div className="min-w-0">
            <p className="support-row-label">Phone</p>
            <p className="support-row-value">+91-8639585257</p>
          </div>
        </Link>

        <Link className="support-row" to="mailto:contact@gettoindia.com">
          <span className="support-row-icon is-mail">
            <FiMail size={16} />
          </span>
          <div className="min-w-0">
            <p className="support-row-label">Email</p>
            <p className="support-row-value">contact@gettoindia.com</p>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Support
